import React from 'react';

import { Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { SalesOrderCalendar } from '../../features/salesOrder/components/SalesOrderCalendar';

export const SalesOrderCalendarPage = (): JSX.Element => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Layout>
			<Grid container sx={{ width: '100%', px: isMobile ? 3 : 5, py: isMobile ? 2 : 3 }}>
				<Grid item xs={12} sx={{ mb: 2 }}>
					<Typography
						variant={isMobile ? 'h5' : 'h4'}
						sx={{
							fontWeight: 500,
							textAlign: 'left',
							fontSize: isMobile ? '1.5rem' : '1.55rem',
						}}
					>
						Calendario de Órdenes
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<SalesOrderCalendar />
				</Grid>
			</Grid>
		</Layout>
	);
};
